import { render, staticRenderFns } from "./profile-view-authorizations.vue?vue&type=template&id=4a3bcb68&scoped=true&"
import script from "./profile-view-authorizations.vue?vue&type=script&lang=js&"
export * from "./profile-view-authorizations.vue?vue&type=script&lang=js&"
import style0 from "./profile-view-authorizations.vue?vue&type=style&index=0&id=4a3bcb68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3bcb68",
  null
  
)

export default component.exports